import cn from 'classnames'
import { Location } from '@reach/router'
import dlv from 'dlv'
import React from 'react'
import Link from '../Link'
import { AppConfig, Image } from '@joehua/cms-components'

const Logo = ({ className }: { className?: string }) => {
  return (
    <Location>
      {({ location }) => (
        <AppConfig>
          {({ title, data }) => {
            const logo = dlv(data, 'logo.id')
            const logoImage =
              location.pathname === '/' ? (
                <Image
                  usePlaceholder
                  title={title}
                  alt={title}
                  id={logo}
                  className={cn('db', className)}
                  transform="w_200"
                  disableLazyload
                />
              ) : (
                <Image
                  usePlaceholder
                  title={title}
                  alt={title}
                  id={logo}
                  className={cn('db', className)}
                  transform="w_200"
                  disableLazyload
                />
              )
            return <Link to={{ name: 'home' }}>{logoImage}</Link>
          }}
        </AppConfig>
      )}
    </Location>
  )
}

export default Logo
